/*!
 *
 * components.js
 *
 */

'use strict';

require('jquery');
require('jquery.easing');
require('jquery.transit');
require('jquery.mousewheel');
require('jquery-mobile-events');
require('origin');
require('slick-carousel');

if (location.hash) {
	location.href = location.hash + '_';
};

var linker = require('linker');
var hashPage = require('hash-page');
var slideScroll = require('slide-scroll');
require('menu');
require('fade-contents');
require('fit-image');
var inputInstagram = require('input-instagram');
require('header-fixed');
hashPage();
$(function(){
	$('.recruit-Visual_Image').slick({
		//dots: true,
		arrows: false,
		slidesToShow: 1,
		//fade: true,
		autoplay: true,
  		autoplaySpeed: 4000

	});
	linker.init();
	slideScroll({
		easing : 'easeOutExpo',
		speed : 700,
		not: '#menu a'
	});

	origin.$window.on("scroll", function(){
		if( !origin.VPisMobile ){
			$(".st-Header").css("left", -$(window).scrollLeft());
		};
	});

	$('.top-Menu a').menu();
	$('.st-Menu a').menu();
	$('.main-Fit').fitImages();
	$('.main-Fit-retina').fitImages({
		isHalf: true
	});

	$('.sw-Fade,.sw-MainFade,.sw-ShiftFade').fadeContents();

	$('.main-Carousel').on('init', function(){
		origin.$window.trigger('fadeInit');
	}).slick({
		dots: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
	origin.$window.trigger('scroll');

	if( $('#InstagramInput').length ){
		inputInstagram();
	};

	$('.top-Header').headerFixed({
		target: $('.top-Visual')
	});
	$('.st-Header').headerFixed({
		target: $('.st-Visual')
	});

});


//////////////////
// WEBPACK FOOTER
// ./dev/js/components.js
// module id = 0
// module chunks = 0